/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_AbbreviationInputs */

const en_reference_field_abbreviation = /** @type {(inputs: Reference_Field_AbbreviationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbreviation`)
};

/**
* | output |
* | --- |
* | "Abbreviation" |
*
* @param {Reference_Field_AbbreviationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_abbreviation = /** @type {((inputs?: Reference_Field_AbbreviationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_AbbreviationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_abbreviation(inputs)
});